import axios from "axios";
import { EDocumentCategory } from "../content/types";

type UploadWeightDocumentRequest = {
  title: string;
  file: File;
  category: EDocumentCategory;
  sectionTitle: string;
  weight?: string;
  measurementDate?: string;
};

type UploadFileEmployee = {
  name: string;
  file: File;
  userId: string;
  onProgress: (percentCompleted: number) => void;
};
export interface IUploadFileName {
  fileId: string;
  newName: string;
}

export const uploadDocument = ({
  title,
  file,
  category,
  sectionTitle,
  weight,
  measurementDate,
}: UploadWeightDocumentRequest) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("document", file);
  formData.append("category", category);
  formData.append("sectionTitle", sectionTitle);

  if (weight) {
    formData.append("weight", weight);
  }

  if (measurementDate) {
    formData.append("measurementDate", measurementDate);
  }

  return axios.post(
    `${process.env.REACT_APP_API_URL}/user-program/document-upload`,
    formData,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const SetDocumentEmployeeUpload = ({
  file,
  name,
  userId,
  onProgress,
}: UploadFileEmployee) => {
  const formData = new FormData();

  formData.append("document", file);
  formData.append("name", name);

  return axios.post(
    `${process.env.REACT_APP_API_URL}/user-program/document-employee-upload/${userId}`,
    formData,
    {
      withCredentials: true,
      onUploadProgress: (progressEvent) => {
        const loaded = progressEvent.loaded;
        const total = progressEvent.total;
        if (total !== undefined) {
          const percentCompleted = Math.round((loaded * 100) / total);

          onProgress(percentCompleted);
        }
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const getfileUserEmployee = async (id: string) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/user-file/${id}`, {
      withCredentials: true,
    })
    .then((response) => response.data);
};

export const updateFileNameEmpoyee = async (
  updateRequest?: IUploadFileName
): Promise<any> => {
  return axios.put(
    `${process.env.REACT_APP_API_URL}/user-program/update-file-name`,
    updateRequest,
    {
      withCredentials: true,
    }
  );
};
